'use client'

import Link from 'next/link'
import { useLocale, useTranslations } from 'next-intl'
import { CalendarIcon, UserIcon } from 'lucide-react'
import { UserAvatar } from '@/components/partials'
import { EffectedUserType, TimestampsType } from '@/types/general'
import { formatDateTime } from '@/lib/date-utils'

type PropsType = {
  entity: EffectedUserType & TimestampsType
}

const ContentDetailInfo = ({ entity }: PropsType) => {
  const t = useTranslations()
  const locale = useLocale()

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-4">
      <div className="space-y-2">
        <div className="text-muted-foreground items-top flex flex-col items-start justify-start gap-2 text-sm font-medium">
          <div className="flex items-center gap-1">
            <UserIcon className="h-4 w-4" />
            {t('created_user')}
          </div>
          {entity.createdUser ? (
            <Link href={`/users/${entity.createdUser.id}`} className="flex items-center gap-2">
              <UserAvatar user={entity.createdUser} size="sm" />
              <div className="flex flex-col">
                <span className="text-sm">{entity.createdUser.fullName}</span>
                <span className="text-muted-foreground text-xs">{entity.createdUser.email}</span>
              </div>
            </Link>
          ) : (
            '-'
          )}
        </div>
      </div>
      <div className="space-y-2">
        <div className="text-muted-foreground flex items-center gap-2 text-sm font-medium">
          <UserIcon className="h-4 w-4" />
          {t('updated_user')}
        </div>
        {entity.updatedUser ? (
          <Link href={`/users/${entity.updatedUser.id}`} className="flex items-center gap-2">
            <UserAvatar user={entity.updatedUser} size="sm" />
            <div className="flex flex-col">
              <span className="text-sm">{entity.updatedUser.fullName}</span>
              <span className="text-muted-foreground text-xs">{entity.updatedUser.email}</span>
            </div>
          </Link>
        ) : (
          <span className="text-sm">-</span>
        )}
      </div>
      <div className="space-y-2">
        <div className="text-muted-foreground flex items-center gap-2 text-sm font-medium">
          <CalendarIcon className="h-4 w-4" />
          {t('created_at')}
        </div>
        <p className="text-sm">{formatDateTime(entity.createdAt, locale)}</p>
      </div>
      <div className="space-y-2">
        <div className="text-muted-foreground flex items-center gap-2 text-sm font-medium">
          <CalendarIcon className="h-4 w-4" />
          {t('updated_at')}
        </div>
        <p className="text-sm">{formatDateTime(entity.updatedAt, locale)}</p>
      </div>
    </div>
  )
}

export default ContentDetailInfo
